/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useMediaQuery, Container, Link, Typography, Stack, Grid } from "@mui/material";

const AuthFooter = () => {
    const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down("sm"));

    return (
        <Grid
            item
            xs={12}
            sx={{ m: 3, mt: 1 }}
            style={{
                bottom: 0,
                position: "sticky",
                padding: "20px",
                borderTop: "1px solid #C0C0C0",
                background: "#F4F4F4",
            }}
        >
            <Container maxWidth='xl'>
                <Stack
                    direction={matchDownSM ? "column" : "row"}
                    justifyContent={matchDownSM ? "center" : "space-between"}
                    textAlign={matchDownSM ? "center" : "inherit"}
                >
                    <Typography variant='subtitle2' color='secondary' component='span'>
                        &copy; SimpliCity<sup>&trade;</sup>
                        2022. Proudly built in Vancouver, BC by the trusted teams at
                        <Typography
                            component={Link}
                            variant='subtitle2'
                            color='secondary'
                            style={{ margin: "6px", fontSize: "14px", textDecorationLine: "underline" }}
                            href='https://radical.io'
                            target='_blank'
                            underline='hover'
                        >
                            Radical I/O
                        </Typography>
                        and
                        <Typography
                            component={Link}
                            variant='subtitle2'
                            color='secondary'
                            style={{ margin: "6px", fontSize: "14px", textDecorationLine: "underline" }}
                            href='https://simplicitydigital.ca/'
                            target='_blank'
                            underline='hover'
                        >
                            Simplicity Digital
                        </Typography>
                    </Typography>

                    <Stack
                        direction={matchDownSM ? "column" : "row"}
                        spacing={matchDownSM ? 1 : 3}
                        textAlign={matchDownSM ? "center" : "inherit"}
                    >
                        <Typography
                            variant='subtitle2'
                            color='secondary'
                            component={Link}
                            href='https://www.radical.io/privacy-policy'
                            target='_blank'
                            underline='hover'
                        >
                            Privacy Policy
                        </Typography>
                        <Typography
                            variant='subtitle2'
                            color='secondary'
                            component={Link}
                            href='https://www.radical.io/terms-of-use'
                            target='_blank'
                            underline='hover'
                        >
                            Terms of Use
                        </Typography>
                        <Typography
                            variant='subtitle2'
                            color='secondary'
                            component={Link}
                            href='https://www.radical.io/contact-us'
                            target='_blank'
                            underline='hover'
                        >
                            Support
                        </Typography>
                    </Stack>
                </Stack>
            </Container>
        </Grid>
    );
};

export default AuthFooter;
